import ApiService from '@/core/services/api.service'
import { EINVOICE_SALE_TYPE } from '@/utils/einvoice.enum'
import { normalizeInvoiceDetail } from './einvoice.adapter'
import { buildWrapperActionEndpoint } from './einvoice.contract'
import { createClientValidationError } from './einvoice.action-errors'

function extractResponseData(payload) {
  return payload?.data || payload || {}
}

function requireWholesaleLane(context, action) {
  if (context?.saleType === EINVOICE_SALE_TYPE.WHOLESALE) {
    return
  }

  throw createClientValidationError(
    'EINVOICE_CANONICAL_ACTION_LANE_MISMATCH',
    `Action "${action}" chỉ hợp lệ cho lane wholesale.`,
    {
      action,
      saleType: context?.saleType || null,
      salesInvoiceId: context?.salesInvoiceId || null,
    },
  )
}

export async function issueEInvoiceAction(context) {
  const { data } = await ApiService.post(
    buildWrapperActionEndpoint(context.salesInvoiceId, context.saleType, 'issue'),
    {},
  )

  return normalizeInvoiceDetail(extractResponseData(data))
}

export async function cancelEInvoiceAction(context, payload) {
  const { data } = await ApiService.post(
    buildWrapperActionEndpoint(context.salesInvoiceId, context.saleType, 'cancel'),
    payload,
  )

  return extractResponseData(data)
}

export async function adjustEInvoiceAction(context, payload) {
  const { data } = await ApiService.post(
    buildWrapperActionEndpoint(context.salesInvoiceId, context.saleType, 'adjust'),
    payload,
  )

  return extractResponseData(data)
}

export async function replaceEInvoiceAction(context, payload) {
  const { data } = await ApiService.post(
    buildWrapperActionEndpoint(context.salesInvoiceId, context.saleType, 'replace'),
    payload,
  )

  return extractResponseData(data)
}

export async function refreshEInvoiceTaxStatusAction(context) {
  const endpointSuffix =
    context.saleType === EINVOICE_SALE_TYPE.WHOLESALE ? 'query-tax-status' : 'query-status'
  const { data } = await ApiService.post(
    buildWrapperActionEndpoint(context.salesInvoiceId, context.saleType, endpointSuffix),
    {},
  )

  return extractResponseData(data)
}

export async function resendEInvoiceEmailAction(context, payload) {
  requireWholesaleLane(context, 'resend-email')
  const { data } = await ApiService.post(
    buildWrapperActionEndpoint(context.salesInvoiceId, context.saleType, 'resend-email'),
    payload,
  )

  return extractResponseData(data)
}
